import { defineMessages } from 'react-intl';

export const scope = 'app.components.RatingModal';

export default defineMessages({
  ratingText: {
    id: `${scope}.ratingText`,
    defaultMessage:
      'Phản hồi của bạn giúp Kamereo nâng cao chất lượng giao hàng và chọn lọc nhà cung cấp tốt hơn. Cảm ơn bạn đã tin tưởng Kamereo.',
  },
  ratingTitle: {
    id: `${scope}.ratingTitle`,
    defaultMessage: 'Phiếu giao gần đây của bạn thế nào?',
  },
  ratingTitle2: {
    id: `${scope}.ratingTitle2`,
    defaultMessage: 'Đánh giá phiếu hàng: {fulfillmentNoteShortCode}',
  },
  ratingSubtext: {
    id: `${scope}.ratingSubtext`,
    defaultMessage: 'Những đóng góp của bạn giúp cho Kamereo phát triển dịch vụ tốt hơn.',
  },
  deliveryNote: {
    id: `${scope}.deliveryNote`,
    defaultMessage: 'Phiếu giao',
  },
  items: {
    id: `${scope}.items`,
    defaultMessage: 'Sản phẩm',
  },
  later: {
    id: `${scope}.later`,
    defaultMessage: 'Để sau',
  },
  submit: {
    id: `${scope}.submit`,
    defaultMessage: 'Gửi đi',
  },
  writeReview: {
    id: `${scope}.writeReview`,
    defaultMessage: 'Viết đánh giá',
  },
  reviewPlaceHolder: {
    id: `${scope}.reviewPlaceHolder`,
    defaultMessage: 'Bạn cảm thấy thế nào?',
  },
  excellent: {
    id: `${scope}.excellent`,
    defaultMessage: 'Tuyệt vời',
  },
  terrible: {
    id: `${scope}.terrible`,
    defaultMessage: 'Kinh khủng',
  },
  good: {
    id: `${scope}.good`,
    defaultMessage: 'Tốt',
  },
  fair: {
    id: `${scope}.fair`,
    defaultMessage: 'Tạm ổn',
  },
  poor: {
    id: `${scope}.poor`,
    defaultMessage: 'Tệ',
  },
  asRequested: {
    id: `${scope}.asRequested`,
    defaultMessage: 'Đúng yêu cầu',
  },
  carefullyPackaged: {
    id: `${scope}.carefullyPackaged`,
    defaultMessage: 'Đóng gói cẩn thận',
  },
  FriendlyDeveliryStaff: {
    id: `${scope}.FriendlyDeveliryStaff`,
    defaultMessage: 'Shipper nhiệt tình',
  },
  OnTimeDelivery: {
    id: `${scope}.OnTimeDelivery`,
    defaultMessage: 'Giao hàng đúng giờ',
  },
  wrongItemsDeliveried: {
    id: `${scope}.wrongItemsDeliveried`,
    defaultMessage: 'Giao hàng sai',
  },
  poorPackaging: {
    id: `${scope}.poorPackaging`,
    defaultMessage: 'Đóng gói sơ sài',
  },
  unfriendlyDeliveryStaff: {
    id: `${scope}.unfriendlyDeliveryStaff`,
    defaultMessage: 'Shipper không thân thiện',
  },
  deliveryWasLate: {
    id: `${scope}.deliveryWasLate`,
    defaultMessage: 'Giao hàng trễ',
  },
});
